export const ContentTypes = {
    Excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ExcelLegacy: 'application/vnd.ms-excel',
    Pdf: 'application/pdf',
} as const;

